export const formatDateTime = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  if (isNaN(date.getTime())) return "-";

  const pad = (n) => String(n).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  let hours = date.getHours();
  const minutes = pad(date.getMinutes());

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours === 0 ? 12 : hours;

  const formattedHours = pad(hours);

  return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
};

export const formatTime = (timeString) => {
  if (!timeString) return "-";

  const [hourStr, minuteStr, secondStr] = timeString.split(":");

  let hours = parseInt(hourStr, 10);
  const minutes = minuteStr || "00";

  if (isNaN(hours)) return "-";

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours === 0 ? 12 : hours;

  const formattedHours = String(hours).padStart(2, "0");

  return `${formattedHours}:${minutes} ${ampm}`;
};

export const formatIsoToDatetime = (isoString) => {
  // Example ISO: "2026-04-06T15:30:00Z"
  const [datePart, timePart] = isoString.split('T');
  const [year, month, day] = datePart.split('-');
  let [hours, minutes] = timePart.replace('Z', '').split(':');

  hours = parseInt(hours, 10);
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12; // 12-hour format

  return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
}

export const to12Hour = (time) => {
  if (!time) return "";

  let [hour, minute] = time.split(":").map(Number);
  const ampm = hour >= 12 ? "PM" : "AM";

  hour = hour % 12;
  if (hour === 0) hour = 12;

  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${ampm}`;
};

export const generateTimeOptions = (
  start = "00:00",
  end = "23:59"
) => {
  const options = [];

  const [startHour, startMinute] = start
    .split(":")
    .map(Number);

  const [endHour, endMinute] = end
    .split(":")
    .map(Number);

  const startTotalMinutes =
    startHour * 60 + startMinute;

  const endTotalMinutes =
    endHour * 60 + endMinute;

  for (
    let minutes = startTotalMinutes;
    minutes <= endTotalMinutes;
    minutes += 15
  ) {
    const hour = Math.floor(minutes / 60);
    const minute = minutes % 60;

    options.push(
      `${String(hour).padStart(2, "0")}:${String(
        minute
      ).padStart(2, "0")}`
    );
  }

  return options;
};

export const getTodayRange = () => {
  const now = new Date();

  // Convert current time to Malaysia time components
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Kuala_Lumpur",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const parts = formatter.formatToParts(now);

  const get = (type) => parts.find(p => p.type === type)?.value;

  const year = get("year");
  const month = get("month");
  const day = get("day");

  // Construct Malaysia "today" boundaries
  const start = new Date(`${year}-${month}-${day}T00:00:00+08:00`);
  const end = new Date(`${year}-${month}-${day}T23:59:59.999+08:00`);

  return {
    startDate: start,
    endDate: end,
  };
};

export const getDaysDiff = (start, end) => {
  const s = new Date(start);
  const e = new Date(end);

  const diff = e.getTime() - s.getTime();
  return diff / (1000 * 60 * 60 * 24);
};